/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreSettings = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15 7h-1.945a5.131 5.131 0 0 0-.772-1.869l1.728-1.727a.999.999 0 1 0-1.414-1.414l-1.728 1.727A5.131 5.131 0 0 0 9 2.945V1a1 1 0 1 0-2 0v1.945a5.131 5.131 0 0 0-1.869.772L3.404 1.99A.999.999 0 1 0 1.99 3.404l1.727 1.727A5.131 5.131 0 0 0 2.945 7H1a1 1 0 1 0 0 2h1.945c.134.681.399 1.313.772 1.869L1.99 12.597a.999.999 0 1 0 1.414 1.414l1.727-1.728A5.131 5.131 0 0 0 7 13.055V15a1 1 0 1 0 2 0v-1.945a5.131 5.131 0 0 0 1.869-.772l1.728 1.728a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-1.728-1.728A5.131 5.131 0 0 0 13.055 9H15a1 1 0 1 0 0-2zm-7 3.156c-1.189 0-2.156-.967-2.156-2.156S6.811 5.844 8 5.844s2.156.967 2.156 2.156S9.189 10.156 8 10.156z"
    />
  </svg>
);

IconCoreSettings.displayName = 'IconCoreSettings';

IconCoreSettings.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreSettings);
IconCoreSettings.displayName = 'IconCoreSettings';
